import React from 'react'
import iconCheckCirclePink from 'images/icons/check-circle-pink.svg'
import iconFacebookCircle from 'images/icons/facebook-circle.svg'
import iconInstagramCircle from 'images/icons/instagram-circle.svg'
import iconLinkedinCircle from 'images/icons/linkedin-circle.svg'
import iconTwitterCircle from 'images/icons/twitter-circle.svg'
import personaPlaceholder from 'images/placeholders/persona.png'
import Very from "../../../helpers/request_wrapper";

class Step1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {  };
  }

  unlockPersona = () => {
    Very.post(`/personas/${this.props.persona.id}/unlock`).then(res => {
      window.location.replace(`/personas/${this.props.persona.id}`)
    }, error => {

    })
  };

  render() {
    const { handleSubmit, persona, can_unlock } = this.props

    return (
      <React.Fragment>
        <h2 className="center title mb-10">Purchase</h2>

        <p className="center h3 mb-30 text-tuna">A new and better way to acquire, engage and support customers.</p>

        <div className="mx-auto" style={{ maxWidth: '440px' }}>
          <div className="bg-white box-shadow-box border border-gallery mb-30 rounded-6">
            <div className="pt-40 px-40">
              <div className="flex flex-center flex-justify-center mb-10 mx-auto">
                <div
                  className="bg-center bg-cover bg-no-repeat border border-white bw-2 circle relative z1"
                  style={{
                    backgroundImage: `url('${persona.photos[0]}')`,
                    boxShadow: '0 0px 15px rgba(0, 0, 0, 0.4)',
                    height: '110px',
                    width: '110px',
                  }}
                />

                <div
                  className="bg-center bg-cover bg-no-repeat border border-white bw-2 circle"
                  style={{
                    backgroundImage: `url('${persona.photos[1]}')`,
                    boxShadow: '0 0px 15px rgba(0, 0, 0, 0.4)',
                    height: '110px',
                    marginLeft: '-20px',
                    width: '110px',
                  }}
                />
              </div>

              <p className="center h2 text-tuna">{persona.name}</p>

            </div>

            <div
              className="border-top border-gallery p-40 rounded-top-6"
              style={{ top: '-10px' }}
            >
              <ul className="ul mb-30 text-tuna">
                <li className="flex flex-center lh-normal mb-20">
                  <img alt="" className="mr-10" src={iconCheckCirclePink} />

                  <span>Customize workflows with rules and automations</span>
                </li>

                <li className="flex flex-center lh-normal mb-20">
                  <img alt="" className="mr-10" src={iconCheckCirclePink} />

                  <span>Create intelligent, multi-touch campaigns</span>
                </li>

                <li className="flex flex-center lh-normal mb-20">
                  <img alt="" className="mr-10" src={iconCheckCirclePink} />

                  <span>Send targeted messages on your website or in-product</span>
                </li>

                <li className="flex flex-center lh-normal mb-20">
                  <img alt="" className="mr-10" src={iconCheckCirclePink} />

                  <span>Target prospects based on profile and behavior</span>
                </li>
              </ul>

              {can_unlock ? <a
                className="btn btn--primary"
                onClick={this.unlockPersona}
              >
                Unlock
              </a> : <a
                href="#"
                className="btn btn--primary"
                onClick={() => handleSubmit()}
              >
                Checkout - {persona.price/100}$
              </a>}
            </div>
          </div>

          <p className="flex flex-center flex-justify-center flex-wrap h6 sfpro-regular">
            <span className="mr-10 sm-center sm-col-12 sm-m0 sm-mb2">Sourced from</span>

            <img alt="" className="block mr-10 sm-mb2" src={iconInstagramCircle} />

            <img alt="" className="block mr-10 sm-mb2" src={iconFacebookCircle} />

            <img alt="" className="block mr-10 sm-mb2" src={iconTwitterCircle} />

            <img alt="" className="block mr-10 sm-mb2" src={iconLinkedinCircle} />
          </p>
        </div>
      </React.Fragment>
    );
  }
}

export default Step1
